import {useState} from "react";
import {CheckoutExperience} from "./checkout-experience";
import {APP_BASE, Link} from "./router";
import {commerceProduct,type CommerceCheckout} from "../src/commerce-types";
import {CRYPTO_ASSETS,cryptoAsset} from "../src/commerce-crypto/assets";
import {decimalToAtomic} from "../src/commerce-crypto/amount";

// Each is a labelled independent example price, not an exchange-rate conversion.
const examplePrices:Record<string,string>={BTC:"0.0001",ETH:"0.005",LTC:"0.1",DOGE:"10",SOL:"0.05",TRX:"25",BNB:"0.01",AVAX:"0.1",CRO:"10",HYPE:"0.1"};
function example(product:"payments"|"crypto",network="bitcoin-mainnet"):CommerceCheckout{
 const asset=product==="crypto"?cryptoAsset(network):null;
 const decimals=asset?.decimals??2;
 const price=asset?examplePrices[asset.currency]: "19.00";
 if(!price)throw Error("This currency does not have a checkout example.");
 return {mode:"preview",merchant:"Atlas Studio",supportEmail:"",offerName:"Project pass",interval:"once",canComplete:true,
  order:{id:"public-checkout-demo",product,description:"Example project access",amountAtomic:decimalToAtomic(price,decimals),
   currency:asset?.currency??"USD",decimals,network:asset?.network??null,state:"open",createdAt:new Date().toISOString(),expiresAt:null,checkoutPath:null}};
}
export function CommerceDemoPage({product}:{product:"payments"|"crypto"}){
 return <DemoContent key={product} product={product}/>;
}
function DemoContent({product}:{product:"payments"|"crypto"}){
 const definition=commerceProduct(product);
 const [data,setData]=useState(()=>{
  const requested=new URLSearchParams(window.location.search).get("asset");
  const network=requested&&CRYPTO_ASSETS.some(asset=>asset.id===requested)?requested:"bitcoin-mainnet";
  return example(product,network);
 });
 function reset(){setData(example(product,data.order.network??"bitcoin-mainnet"));}
 function outcome(state:"completed"|"failed"|"refunded"){setData(current=>({...current,canComplete:false,order:{...current.order,state}}));}
 return <div className="commerce commerce-public commerce-demo">
  <header className="commerce-hero"><p className="commerce-eyebrow">{definition.name} · Checkout preview</p>
   <h1>{product==="crypto"?"A familiar way to pay with crypto.":"Your project. A complete checkout."}</h1>
   <p>View an example checkout and receipt. No account is required.</p>
  </header>
  <CheckoutExperience data={data} pending={false} demo simulate={outcome} reset={reset} refund={()=>outcome("refunded")}
   {...(product==="crypto"?{onAssetChange:(network:string)=>setData(example(product,network))}:{})}/>
  <section className="commerce-launch-note"><h2>Put it to work in your project.</h2>
   <p>Use your EightBots account to create products and manage payment previews.</p>
   <div className="commerce-actions">
    <Link className="button" href={APP_BASE+definition.accountPath}>Open my account</Link>
    <Link className="commerce-text-link" href={APP_BASE+definition.publicPath}>About {definition.name}</Link>
   </div>
  </section>
 </div>;
}
